export enum NotificationType {
  RegisterGuard = 1,
  RegisterCompany = 2,
  RegisterGovernmentUser = 3,
  RegisterRasdUser = 4,
  OrderAdd = 5,
  OrderUpdate = 6,
  ContractAdd = 7,
  ContractUpdate = 8,
  JopAdd = 9,
  JopUpdate = 10,
  JopApplay = 11,
  RasdInfractionAdd = 12,
  RasdInfractionUpdate = 13,
  GuardAttendance = 14,
  GuardLogOutAttendance = 14,
  GuardStartBreack = 15,
  GuardEndBreack = 16,
  GuardLateOnAttend = 17,
  RegisterClient = 18,
  Task = 19,
  TaskUpdate = 20,
  Tour = 21,
  TourUpdate = 22,
  SwapShift = 23,
  SwapShiftUpdated = 24,
  expiredPackage = 1
}
